export default "__VITE_ASSET__CLk1rbZk__"